import { nonRecoverableTaxes, pickByConcept } from '@/businessLogic/transferCalculations';
import { Concept } from '@/constants/scenarios';
import { db } from '@/lib/firebase';
import { TransferPair, TransferPairResponse } from '@/types/transfer-pair';
import { getFlagEmoji } from '@/utils/get-flag';
import { doc, getDoc } from 'firebase/firestore';

export function makePairId(originId: string, destId: string) {
  return `${originId}_${destId}`;
}

export async function getTransferPair(params: {
  customerId: string;
  vendorId: string;
  concept: Concept;
  invoicingCurrency: string;
}): Promise<TransferPair | null> {
  const origin = params.customerId.trim().toUpperCase();
  const dest = params.vendorId.trim().toUpperCase();
  const pairId = `${origin}_${dest}`;

  const snap = await getDoc(doc(db, 'transfer_pairs', pairId));
  if (!snap.exists()) return null;

  const data = snap.data() as TransferPairResponse;
  const customerCurrency = data.originCurrencyISO.toLowerCase();

  const exchangeRate = await fetch(
    `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json`,
  )
    .then(res => res.json())
    .then(res => {
      return res['usd'][customerCurrency];
    })
    .catch(() => 1);

  const wht = pickByConcept(params.concept, {
    infrastructure: data.whtInfrastructure ?? 0,
    licenses: data.whtLicenses ?? 0,
    service: data.whtService ?? 0,
    support: data.whtSupport ?? 0,
  });

  const nonRecTaxes = nonRecoverableTaxes(data);

  const flagOrigin = getFlagEmoji(data.originId);
  const flagDest = getFlagEmoji(data.destId);

  return {
    exchangeRate: Math.round(exchangeRate * 1000) / 1000,
    pairId,
    ...data,
    originName: flagOrigin ? `${flagOrigin} ${data.originName}` : data.originName,
    destinyName: flagDest ? `${flagDest} ${data.destinyName}` : data.destinyName,
    concept: params.concept,
    wht,
    nonRecTaxes: nonRecTaxes,
  };
}
